import { createFeatureSelector } from '@ngrx/store';
import { QuestionState } from './questions.reducers';

export const getQuestionsState = createFeatureSelector<QuestionState>(
  'questions'
);
